import React from 'react'
import DetailContainer from '../MainPage/common/DetailContainer'
import { images } from '../common/images';

function CurrentDetailContainer({ phaseLoadLogs, phaseWiseData, phase, deviceId, multipleDaysLogs, phaseInName = true, live = true }) {

  // Find the last valid log that doesn't have the 'ct' key which means that log will be of 'disconnect' type
  const validPhaseData = phaseWiseData.filter(log => !log.hasOwnProperty('ct')).sort((a, b) => a.ts - b.ts);

  // Check if there is a valid log to display
  const lastValidLog = validPhaseData.length > 0 ? validPhaseData[validPhaseData.length - 1] : null;

  return (
    <DetailContainer
      name={`Current${phaseInName && Object.keys(phaseLoadLogs[deviceId]).length > 1 ? ` ${Number(phase) + 1}` : ''}`}
      value={`${(lastValidLog
        ? lastValidLog.c
        : 0
      ).toFixed(2)} A`}
      time={
        Object.keys(phaseLoadLogs)?.length !== 0 &&
          phaseWiseData.length !== 0 &&
          lastValidLog !== null &&
          lastValidLog.ts !== undefined &&
          lastValidLog.ts !== null
          ? lastValidLog.ts
          : 0
      }
      showDay={multipleDaysLogs?.length > 1 ? true : false}
      hasLog={lastValidLog !== null}
      reading
      live={live}
      color={"rgba(16, 163, 127, 0.10)"}
      borderColor={"#EF4444"}
      image={images.chartCurrent}
    />
  )
}

export default CurrentDetailContainer